import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class HasPermissionGuard {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this._doCheck(route, state);
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this._doCheck(childRoute, state);
  }

  private _doCheck(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.authService.isLoggedIn().pipe(
      switchMap((resp): Observable<boolean> => {
        if (resp) {
          // if a permission and access level is defined, check with authService
          if (
            route.data.permission &&
            route.data.access &&
            !this.authService.hasPermission(route.data.permission, route.data.access)
          ) {
            this.router.navigate(['/access-denied']);
            return of(false);
          }

          return of(true);
        } else {
          // redirect user to the requested route after login
          sessionStorage.setItem('auth-redirect', state.url);
          this.authService.startAuthentication();
          return of(false);
        }
      })
    );
  }
}
